// File: src/firebase-config.ts

import { initializeApp } from "firebase/app";
import { getAuth, SAMLAuthProvider } from "firebase/auth";
import ENV_CONFIG from './config/environment';

const firebaseConfig = ENV_CONFIG.FIREBASE_CONFIG;

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Export the SAML Auth provider for use in the login flow
export const samlProvider = new SAMLAuthProvider('saml.randstad');

export default app;
